/* eslint-disable @typescript-eslint/no-explicit-any */

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import {
	Text,
	Box,
	Image,
	rem,
	Group,
	Container,
	Tooltip,
} from '@mantine/core';

// Components
import { Button } from '@components/atoms/Button';

// Icons
import CalendarIcon from '@assets/icons/calendar.svg';

// Styles
import classes from './RowImportHistory.module.css';
import clsx from 'clsx';

// I18n
import { useTranslation } from 'react-i18next';
import {
	capitalizeString,
	getMintStatusLabel,
	getMintStatusType,
	truncateString,
} from '@utils/functions';
import { MintStatus } from '@components/atoms';
import { TImportHistory } from '@pages/ImportHistory/types';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const RowImportHistory = (props: {
	verified: boolean;
	data: TImportHistory;
	handleviewdetails: () => void;
}) => {
	/* ******************************** HOOKS ******************************* */
	const { t } = useTranslation();

	/* ******************************** RENDERING ******************************* */
	return (
		<Container className={classes.row}>
			<Box
				className={clsx(classes.col, classes.colProject)}
			>
				<Text className={classes.title}>
					{t('global.filename')}
				</Text>
				<Tooltip
					label={props.data.filename}
					disabled={
						props.data.filename &&
						props.data.filename.length < 28
							? true
							: false
					}
				>
					<Text className={classes.value}>
						{truncateString(props.data.filename, 28)}
					</Text>
				</Tooltip>
			</Box>
			<Box className={classes.col}>
				<Group gap={'5px'}>
					<Image
						style={{ width: rem(18), height: rem(18) }}
						src={CalendarIcon}
					/>
					<Text className={classes.title}>
						{t('global.importDate')}
					</Text>
				</Group>

				<Text className={classes.value}>
					{props.data.importDate}
				</Text>
			</Box>
			<Box className={classes.col}>
				<Text className={classes.title}>
					{t('global.lineCount')}
				</Text>
				<Text className={classes.value}>
					{props.data.lineCount}
				</Text>
			</Box>
			<Box className={classes.col}>
				<MintStatus
					type={getMintStatusType(
						props.data.status.toUpperCase()
					)}
				>
					{capitalizeString(
						getMintStatusLabel(props.data.status)
					)}
				</MintStatus>
			</Box>
			<Box className={classes.col}>
				<Box className={classes.containerButton}>
					<Button
						disabled={props.data.status !== 'SUCCESS'}
						onClick={props.handleviewdetails}
						fullWidth
						variant="outline"
						size="sm"
					>
						{t('global.viewDetails')}
					</Button>
				</Box>
			</Box>
		</Container>
	);
};
